import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';

import { AuthService } from '../../../../core/auth/auth.service';

import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatRippleModule, MatIconModule],
})
export class ToolbarUserComponent {
  private readonly popover = inject(VexPopoverService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly auth = inject(AuthService);

  dropdownOpen = false;

  /** Nombre del usuario logueado (signal-derived) para mostrar en el toolbar. */
  readonly nombre = computed(() => this.auth.user()?.nombre ?? 'Invitado');

  showPopover(originRef: HTMLElement): void {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom',
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
